var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"inAboutconBox"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"inAboutCulture"},[(_vm.cultureInfo.ico)?_c('img',{attrs:{"src":_vm.$root.$TEMP_URL+_vm.cultureInfo.ico}}):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39bc242e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About/Culture/Culture.vue
// module id = V8lE
// module chunks = 1